import useMergedState from 'rc-util/lib/hooks/useMergedState';
import { FC, memo } from 'react';

import Radio from './Radio';
import s from './Radio.module.scss';
import { RadioGroupContextProvider } from './context';
import { RadioChangeEvent, RadioGroupProps } from './interfaces';

const RadioGroup: FC<React.PropsWithChildren<React.PropsWithChildren<RadioGroupProps>>> = ({ defaultValue, ...restProps }) => {
  const [value, setValue] = useMergedState<RadioGroupProps['defaultValue'], RadioGroupProps['value']>(defaultValue, {
    value: restProps.value
  });

  const onRadioChange = (ev: RadioChangeEvent) => {
    const lastValue = value;
    const val = ev.target.value;
    if (!restProps.value) {
      setValue(val);
    }
    const { onChange } = restProps;
    if (onChange && val !== lastValue) {
      onChange(ev);
    }
  };

  const renderGroup = () => {
    const { options, disabled, children, id } = restProps;
    let childrenToRender = children;
    if (options && options.length > 0) {
      childrenToRender = options.map((option) => {
        if (typeof option === 'string' || typeof option === 'number') {
          return (
            <Radio key={option.toString()} id={id as string} disabled={disabled} value={option} checked={value === option}>
              {option}
            </Radio>
          );
        }
        return (
          <Radio key={option?.toString()} id={id as string} disabled={option?.disabled || disabled} value={option?.value} checked={value === option?.value}>
            {option?.label}
          </Radio>
        );
      });
    }
    return (
      <div id={id} className={s.group}>
        {childrenToRender}
      </div>
    );
  };
  return (
    <RadioGroupContextProvider
      value={{
        onChange: onRadioChange,
        value,
        disabled: restProps?.disabled
      }}
    >
      {renderGroup()}
    </RadioGroupContextProvider>
  );
};

export default memo(RadioGroup);
